import voiceCallIndex from '@/views/scene/voiceCall/index.vue';
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `voiceCall/index${i + 1}`,
  name: `voiceCallIndex${i + 1}`,
  component: () => import(`@/views/scene/voiceCall/index${i + 1}.vue`)
}))

export default {
  path: '/scene',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
     // 微信语音电话首页
    {
      path: 'voiceCallIndex',
      name: 'voiceCallIndex',
      component: voiceCallIndex
    },
    ...MainRoutes,
  ]
}
